<template>
  <div class="list-layout">
    <el-row type="flex" justify="space-between">
      <el-col class="title-bar" :span="8">
        <slot name="title"></slot>
      </el-col>
      <el-col class="action-bar" :span="16">
        <slot name="action-bar"></slot>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="btn_tabs" :span="24">
        <slot name="btn_tabs"></slot>
      </el-col>
    </el-row>
    <el-row>
      <v-card class="search-bar">
        <slot name="search-bar"></slot>
        <slot name="apply-box"></slot>
      </v-card>
    </el-row>
    <el-row>
      <v-card class="main-content">
        <slot name="tabs"></slot>
        <slot name="table_area"></slot>
        <slot name="main-content"></slot>
        <slot name="pagination">
          <el-pagination
            class="text-center"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :current-page="currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </slot>
      </v-card>
    </el-row>
  </div>
</template>

<script>
import vCard from '@/components/common/Card'
export default {
  data() {
    return {
    }
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  components: {
    vCard,
  },
  methods: {
    handleSizeChange(pageSize) {
      this.$emit('size-change', pageSize)
    },
    handleCurrentChange(currentPage) {
      this.$emit('current-change', currentPage)
    },
  },
}
</script>

<style lang="less">
.list-layout {
  .title-bar {
    margin-top: 10px;
    margin-bottom: 30px;
    p, span, h1, h2, h3, h4, h5, h6 {
      font-size: 26px;
      color: #86939e;
      margin: 0;
    }
  }

 /* .el-table .cell{
    padding:0;
  }*/
  .el-table__header-wrapper .el-table .cell{
    padding:15px;
  }
/*  .timedata .el-table-column--selection .cell{
    padding-left: 0;
    padding-right: 0;
  }*/
 /* .el-table .cell, .el-table th>div{
    padding: 0;
  }*/
  .el-pagination{
    margin-top:10px;
  }
  .complex-table .table-header > .el-col{
    font-size: 14px;
  }
  .tab .el-tabs__header{
    position: relative;
  }
  .search-bar {
    min-height: 40px;
    margin-bottom: 20px;
  }
  .main-content {
    min-height: 300px;
  }
  .el-tabs__active-bar{
    background-color: rgba(0,0,0,0);
  }
  .complex-table .table-header{
    height: 42px;
    line-height: 42px;
    background: #fff;
    font-weight: bold;
    text-align: left;
  }
  .complex-table .sub-row-table .sub-body [data-v-31368ffa]:last-child{
    border: none;
  }
  .text-right{
    text-align: right;
  }
  .btn_tabs{
    .el-tabs__header{
      border-bottom: none;
    }
    .el-tabs__item.is-active{
      background: #20a0ff;
      color: #fff;
    }
    .el-tabs__item{
      border-radius: 100px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      color: #5E6977;
      background: #CFD6DB;
      margin-right: 10px;
    }
  }
  .table_area{
    table{
      width: 100%;
      border-collapse: collapse;
      thead{
        td{
          background: #E6E9F2;
          font-size: 14px;
          color: #43484D;
        }
        th{
          padding:0 10px;
          background: #E6E9F2;
          font-size: 14px;
          color: #43484D;
          .cell{
            background: #E6E9F2;
          }
        }
      }
      td{
        padding: 10px;
      }
      tbody{
        border: 1px solid #E0E6ED;
      }
      tbody td{
        font-size: 14px;
        color: #1F2D3D;
        border-bottom: 1px solid #E0E6ED;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// ListLayout.vue?fda7d232